(function($){
        
	// initializeAlphaSorter();


})(jQuery);


function initializeAlphaSorter(){
	// Add Loaded Class
	$('.ptx-alphasorter').addClass('ptx-alphasorter--loaded');
  

	//.ptx-coursenav button
	$( ".ptx-alphasorter__alphalist a" ).on( "click", function(event) {
	


		/*
	

		var destinationID = $(this).attr('href');
			// destinationID = destinationID.replace('#', '')
			// console.log($(destinationID));

			var alphaTopPosition = $('.ptx-alphasorter__right').position().top;
			var alphaScrollPosition = $('.ptx-alphasorter__right').scrollTop();
			var destinationPosition = $(destinationID).offset().top;
			
			console.log("scroller top", alphaTopPosition);
			console.log("inner scroll ", alphaScrollPosition);
			console.log("ID top ",destinationPosition);

			
			thinger.scrollTo({
				top: $(destinationID).offset().top,
				left: 0,
				behavior: 'smooth'
			  });
			*/
		


		/*
			var offset= $(destinationID).offset()
			console.log("offset", offset);
			var position= $(destinationID).position()
			console.log("position", position);
	
		var scrollAmount = $(destinationID).position().top;
		var offsetTop = $(destinationID).offset().top;
		var sorterPosition = $('.ptx-alphasorter__right').position().top;
		var difference = sorterPosition - scrollAmount;

		alert("scroll, offset are " + scrollAmount + " " + offsetTop);
		// alert(destinationID + "top is " +  + 'sorter top is at ' + sorterPosition + "diff of " + difference);

		$('.ptx-alphasorter__right').animate({
			scrollTop: difference
		}, 0);
	
			
		
		document
			.getElementById(destinationID)
			.scrollIntoView({ behavior: "smooth" });
	*/
		//  $(destinationID).offset().top
		
/*
		$('.ptx-alphasorter__scrollist').scrollTo({
			top: $(destinationID).offset().top,
			left: 0,
			behavior: 'smooth'
		  });
		  */
	
	});

	

	// Change Filters to Hide/SHow based on Taxonomy
	$('.ptx-alphasorter__control input').change(function() {
		// Identify Parent Control
		var $alphasorter = $(this).parents('.ptx-alphasorter');
		// Group inputs based on name property
		var dynamicName = $(this).attr('name');
		// Create an empty array to save checked values
		var favorites = ['ptx-alphasorter', 'ptx-alphasorter--loaded'];
		// Query all items checked in this group that are checked
		var allChecked = $('input[name="'+dynamicName+'"]:checked'); // .ptx-alphasorter__control 
		// Identify unique IDs and add to the favorites array;
		$.each(allChecked, function(){ 
			var customClassName = 'ptx-alphasorter--has-'+dynamicName+'-'+$(this).attr('id');
			if(allChecked.length > 0){favorites.push('ptx-alphasorter--has-filtering');}
			favorites.push(customClassName);
		});
		// Remove Classes and add new ones
		$alphasorter.attr('class', '').addClass(favorites);
		// provide developer feedback
		console.log("selected " + dynamicName + 's ', favorites);
		/*
		var dynamicSelector = $(this).attr('name');
		
		"input[name=chkboxName]:checked";
		var checklist =   alert($("input[name=chkboxName]:checked").map(function () {
			return this.value;
		  }).get().join(","));
		$('#textbox1').val($(this).is(':checked'));
		*/
	  });
}